import * as core from '../../../../../../../core'

import { query } from './net-roi-by-project.query'

export const RESOURCE = {
  payload: {
    alias: 'net.roi.by.project',
    description:
      'Bar chart showing net ROI from Cursor usage, grouped by project. Not yet implemented.',
    name: 'Net ROI by Project',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
